import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { GET, GET_CLAIM_DETAIL } from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { toUploadFileList } from '../../../../functions/imageUpload';

export const useGetClaimEdit = ({ claimCode, reset }) => {
  const [data, setData] = useState();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_CLAIM_DETAIL(claimCode));
      return response.result;
    },
    onSuccess: (result) => {
      setData(result);

      const formattedBookingDate = result?.claim?.bookingDate
        ? dayjs(result.claim.bookingDate).format('DD/MM/YYYY')
        : undefined;

      reset({
        ...result?.claim,
        bookingDate: formattedBookingDate,
        claimImageUrl: toUploadFileList(result?.claim?.claimImageUrl),
        receiptImageUrl: toUploadFileList(result?.claim?.receiptImageUrl),
      });
    },
  });

  useEffect(() => {
    if (claimCode) {
      mutate();
    }
  }, [claimCode]);

  return { dataSource: data, loading: isPending };
};
